export const CustomerEditDialogTitle = {
  add: '顧客新規登録',
  update: '顧客情報編集',
};
